import _ from 'lodash';
import gmt from '../gmt';

export default {
  mixins: [gmt],
  methods: {
    keyValues(org) {
      return [
        {
          label: 'Active',
          value: org.active ? 'Yes' : 'No',
          icon: 'circle',
          centered: true,
        },
        {
          label: 'Name',
          value: org.name,
          link: {
            name: 'admin.organizations.index.detail',
            params: { id: org.uuid },
          },
          icon: 'name',
        },
        {
          label: 'Domain',
          value: org.hd,
          icon: 'org',
        },
        {
          label: 'Vanity',
          value: `${org.vanity}.${process.env.VUE_APP_PRIMARY_DOMAIN}`,
          icon: 'web',
        },
        {
          label: 'Logins',
          value: _.map(org.loginConfig.logins, l => l.connector).join(', '),
          icon: 'web',
        },
        {
          label: 'DB Migration',
          value: org.migration,
          icon: 'org',
        },
        {
          label: 'Description',
          value: org.description,
          icon: 'description',
        },
        {
          label: 'Users',
          value: org.users.join(', '),
          icon: 'circle',
        },
        {
          label: '# Assets',
          value: org.assetCount,
          icon: 'circle',
          centered: true,
        },
        {
          label: '# Users',
          value: org.users.length,
          icon: 'circle',
          centered: true,
        },
        {
          label: '# Alerts',
          value: org.alertCount,
          icon: 'circle',
          centered: true,
        },
        {
          label: '# Logs',
          value: org.logCount,
          icon: 'circle',
          centered: true,
        },
        {
          label: 'Created',
          value: this.$options.filters.formatEpochDate(org.created, this.gmt),
          icon: 'cal',
        },
        {
          label: 'Modified',
          value: this.$options.filters.formatEpochDate(org.updated, this.gmt),
          icon: 'cal',
        },
        {
          label: 'CAID',
          value: org.caid,
          icon: 'circle',
        },
        {
          label: 'CSRID',
          value: org.csrid,
          icon: 'circle',
        },
      ];
    },
  },
};
